module.exports = __webpack_public_path__ + "static/media/1_1.e31aa95a.png";